/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { SvgHandler } from "../svg-handler/svg-handler";
import hamburgerIcon from "../../../assets/icons/hamburger.svg";
import closeIcon from "../../../assets/icons/social/close.svg";
import { CSSTransition } from "react-transition-group";
import { getMenuData } from "./header-helper-components";
import get from "lodash/get";
import SidebarTemplate from "./sidebar/index";

class HeaderSidebarBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }


  displayStatus = (isSidebarVisible) => {
    if (!isSidebarVisible) {
      return <SvgHandler xlinkHref={hamburgerIcon} width="24" height="24" svgWrapperClazzName="svg-wrapper" />;
    } else {
      return (
        <>
          <SvgHandler
            xlinkHref={closeIcon}
            clazzName="closeIcon"
            width="24"
            height="24"
            svgWrapperClazzName="svg-wrapper desktop"
          />
          <SvgHandler xlinkHref={hamburgerIcon} width="24" height="24" svgWrapperClazzName="svg-wrapper mobile" />
        </>
      );
    }
  };

  render() {
    const {
      publisherName,
      socialLinks,
      languageDirection,
      header = {},
      closeAll,
      menuItems,
      toggleSidebar,
      isSingleLayer,
      pageBuilderConfig,
      socialFollowStyle,
      appStoreDownloadLink,
      googlePlayDownloadLink,
      localizedElementsData = {},
      sketchesHost,
    } = this.props;
    const { isSidebarVisible } = header;
    const { buttonLabels = {} } = localizedElementsData;
    const { subscribe: localizedSubscribe } = buttonLabels;
    return (
      <div onClick={toggleSidebar}>
        <div>{this.displayStatus(isSidebarVisible)}</div>
        <CSSTransition in={isSidebarVisible} timeout={{ enter: 300, exit: 500 }} classNames="side-bar-transition">
          <div>
            {isSidebarVisible && (
              <SidebarTemplate
                customCssClasses=""
                isSidebarVisible={isSidebarVisible}
                closeSidebar={toggleSidebar}
                closeAll={closeAll}
                menuItems={menuItems}
                publisherName={publisherName}
                languageDirection={languageDirection}
                socialLinks={socialLinks}
                headerClass={isSingleLayer ? "single-layer" : ""}
                pageBuilderConfig={pageBuilderConfig}
                socialStyle={socialFollowStyle}
                appStoreDownloadLink={appStoreDownloadLink}
                googlePlayDownloadLink={googlePlayDownloadLink}
                localizedSubscribe={localizedSubscribe}
                memberSubscriptions={this.props.memberSubscriptions}
                sketchesHost={sketchesHost}
              />
            )}
          </div>
        </CSSTransition>
      </div>
    );
  }
}
HeaderSidebarBase.propTypes = {
  header: PropTypes.shape({
    isSidebarVisible: PropTypes.bool,
  }),
  toggleSidebar: PropTypes.func,
  menuItems: PropTypes.array,
  closeAll: PropTypes.func,
  publisherName: PropTypes.string,
  socialLinks: PropTypes.object,
  languageDirection: PropTypes.string,
  isSingleLayer: PropTypes.bool,
  pageBuilderConfig: PropTypes.object,
  socialFollowStyle: PropTypes.string,
  enableAppDownloadLinks: PropTypes.bool,
  appStoreDownloadLink: PropTypes.string,
  googlePlayDownloadLink: PropTypes.string,
  localizedElementsData: PropTypes.shape({
    buttonLabels: PropTypes.shape({
      subscribe: PropTypes.string,
    }),
  }),
  sketchesHost: PropTypes.string,
};

const mapStateToProps = (state) => {
  const menu = get(state.qt, ["data", "navigationMenu"], []);
  const { config } = get(state, ["qt"], {});
  const domainSlug = get(config, ["domainSlug"], "");
  const menuItems = getMenuData(menu, "sidebar-menu", domainSlug);
  const { enableLocalization = false, localizedElements = {} } = get(
    state.qt,
    ["config", "pagebuilder-config", "general", "localization"],
    {}
  );
  return {
    header: state.header || {},
    publisherName: get(config, ["publisher-name"], "Madrid"),
    socialLinks: get(config, ["social-links"], {}),
    isSingleLayer: get(config, ["pagebuilder-config", "header", "headerStyle"], "header_1").includes("single"),
    pageBuilderConfig: get(config, ["pagebuilder-config"], {}),
    socialFollowStyle: get(config, ["pagebuilder-config", "header", "socialFollowStyle"], "circular-color-svg"),
    enableAppDownloadLinks: get(config, ["pagebuilder-config", "header", "enableAppDownloadLinksButton"], false),
    appStoreDownloadLink: get(
      config,
      ["pagebuilder-config", "general", "appDownloadLinks", "appStoreDownloadLink"],
      ""
    ),
    googlePlayDownloadLink: get(
      config,
      ["pagebuilder-config", "general", "appDownloadLinks", "googlePlayDownloadLink"],
      ""
    ),
    menuItems,
    localizedElementsData: enableLocalization ? localizedElements : {},
    languageDirection: get(config, ["language", "direction"], "ltr"),
    sketchesHost: get(config, ["sketches-host"], ""),
    memberSubscriptions: get(state, ['memberSubscriptions'], []),
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleSidebar: () => dispatch({ type: "TOGGLE_SIDEBAR_MENU" }),
  closeAll: () => dispatch({ type: "CLOSE_ALL" }),
});

export const HeaderSidebar = connect(mapStateToProps, mapDispatchToProps)(HeaderSidebarBase);

export { HeaderSidebarBase };
